import React from "react";
import Style from "./CurrentPeykAccepted.module.css";
import { separate } from "../../Functions/NumberSeprator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkedAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-jalaali";
import { Popconfirm } from "antd";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import { DeliveryRequestAccesptApi } from "../../Api/DeliveryBarest";
const CurrentPeykAccepted = ({ data, UpdateReq }) => {
  const history = useHistory();

  const OpenMapHandler = (lat, lng) => {
    // Universal geo link
    const geoUrl = `geo:${lat},${lng}?q=${lat},${lng}`;

    // Backup web link (in case desktop browser)
    const webUrl = `https://maps.google.com/?q=${lat},${lng}`;

    // Try to open geo: (mobile)
    window.location.href = geoUrl;

    // After short delay, fallback for browsers that don't support geo:
    setTimeout(() => {
      window.open(webUrl, "_blank");
    }, 500);
  };

  const cancelRequestHandler = () => {
    let info = {
      id: data.id,
      action: "cancel",
      cause: "for action cancel",
    };
    DeliveryRequestAccesptApi(info, (res) => {
      if (res.status === 1) {
        succToast("سفرشما کنسل شد!");
        setTimeout(() => {
          history.push("/");
        }, 1000);
      } else {
        errorToast(res.message);
      }
    });
  };
  const situationHandler = (situationStatus, rootId) => {
    let info = {
      id: data.id,
      action:
        situationStatus === "1"
          ? "arrive"
          : situationStatus === "2"
          ? "getting_in"
          : null,
      route_id: rootId,
    };
    DeliveryRequestAccesptApi(info, (res) => {
      if (res.status === 1) {
        succToast("بروز رسانی وضعیت انجام شد!");
        UpdateReq();
      } else {
        errorToast(res.message);
      }
    });
  };
  return (
    <section className={Style.RequestSectionHolder}>
      <p className={Style.HeaderOfSection}>
        <span>درخواست پیک</span>
        <span>شماره سفارش:{data?.id}</span>
      </p>
      <div className={Style.locationHolder}>
        <p>
          <span>نام فرستنده:</span>
          {data?.delivery_routes[0]?.name}
        </p>
        <p>
          <span>شماره فرستنده:</span>
          <a href={`tel:${data?.delivery_routes[0]?.phone}`}>
            {data?.delivery_routes[0]?.phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>مبدا:</span>
          {data?.delivery_routes[0]?.description}
          <button
            className={Style.mapBtn}
            onClick={() =>
              OpenMapHandler(
                data?.delivery_routes[0]?.lat,
                data?.delivery_routes[0]?.lon
              )
            }
          >
            نقشه <FontAwesomeIcon icon={faMapMarkedAlt} />
          </button>
        </p>

        {data?.delivery_routes[0]?.routes_description && (
          <p>
            <span>توضیحات:</span>
            {data?.delivery_routes[0]?.routes_description}
          </p>
        )}
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>نام گیرنده:</span>
          {data?.delivery_routes[1]?.name}
        </p>
        <p>
          <span>شماره گیرنده:</span>
          <a href={`tel:${data?.delivery_routes[1]?.phone}`}>
            {data?.delivery_routes[1]?.phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>مقصد:</span>
          {data?.delivery_routes[1]?.description}
          <button
            className={Style.mapBtn}
            onClick={() =>
              OpenMapHandler(
                data?.delivery_routes[1]?.lat,
                data?.delivery_routes[1]?.lon
              )
            }
          >
            نقشه <FontAwesomeIcon icon={faMapMarkedAlt} />
          </button>
        </p>
        {data?.delivery_routes[1]?.routes_description && (
          <p>
            <span>توضیحات:</span>
            {data?.delivery_routes[1]?.routes_description}
          </p>
        )}
      </div>
      {data?.delivery_routes[2] && (
        <div className={Style.locationHolder}>
          <p>
            <span>نام گیرنده دوم:</span>
            {data?.delivery_routes[2]?.name}
          </p>
          <p>
            <span>شماره گیرنده دوم:</span>
            <a href={`tel:${data?.delivery_routes[2]?.phone}`}>
              {data?.delivery_routes[2]?.phone}{" "}
              <FontAwesomeIcon icon={faPhone} />
            </a>
          </p>
          <p>
            <span>مقصد دوم:</span>
            {data?.delivery_routes[2]?.description}
            <button
              className={Style.mapBtn}
              onClick={() =>
                OpenMapHandler(
                  data?.delivery_routes[2]?.lat,
                  data?.delivery_routes[2]?.lon
                )
              }
            >
              نقشه <FontAwesomeIcon icon={faMapMarkedAlt} />
            </button>
          </p>
          {data?.delivery_routes[2]?.routes_description && (
            <p>
              <span>توضیحات:</span>
              {data?.delivery_routes[2]?.routes_description}
            </p>
          )}
        </div>
      )}

      <div className={Style.locationHolder}>
        <p>
          <span>نام درخواست دهنده:</span>
          {data?.requested_user_name}
        </p>
        <p>
          <span>شماره درخواست دهنده:</span>
          <a href={`tel:${data?.requested_user_phone}`}>
            {data?.requested_user_phone} <FontAwesomeIcon icon={faPhone} />
          </a>
        </p>
        <p>
          <span>نوع وسیله:</span>
          {data?.category}
        </p>
        <p>
          <span>توضیحات وسیله:</span>
          {data?.product_description}
        </p>
        <p>
          <span>زمان درخواست وسیله:</span>
          {moment
            .unix(parseInt(data?.request_date))
            .format("jYYYY/jM/jD--hh:mm")}
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span> مسافت حدودی:</span>
          {data?.distance} متر
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>کرایه:</span>
          <strong style={{ color: "green" }}>
            {separate(data?.delivery)} تومان
          </strong>
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>وضعیت پرداخت:</span>
          {data?.paid === "1" ? (
            <strong style={{ color: "green" }}>پرداخت شد</strong>
          ) : (
            <strong style={{ color: "red" }}>پرداخت نشده</strong>
          )}
        </p>
      </div>
      <div className={Style.buttonHolder}>
        <Popconfirm
          style={{ direction: "rtl" }}
          title="آیا مطمئنید؟"
          onConfirm={cancelRequestHandler}
          okText="بله"
          cancelText="خیر"
        >
          <button className={Style.AcceptButton}>لغو درخواست</button>
        </Popconfirm>
        {data?.status === "1" ? (
          <button
            className={Style.situationBtn}
            onClick={() => situationHandler("1")}
          >
            به مبدا رسیدم
          </button>
        ) : null}
        {data?.status === "2" ? (
          <button
            className={Style.situationBtn}
            onClick={() => situationHandler("2")}
          >
            کالا رو تحویل گرفتم
          </button>
        ) : null}
        {data?.status === "3" && data?.delivery_routes[1].status !== "1" ? (
          <button
            className={Style.situationBtn}
            onClick={() => situationHandler("2", data?.delivery_routes[1]?.id)}
          >
            {data?.delivery_routes[2] ? "به مقصد رسیدم" : "به مقصد اول رسیدم"}
          </button>
        ) : null}
        {data?.status === "3" && data?.delivery_routes[1]?.status === "1" ? (
          <button
            className={Style.situationBtn}
            onClick={() => situationHandler("2", data?.delivery_routes[2]?.id)}
          >
            به مقصد دوم رسیدم و اتمام
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default CurrentPeykAccepted;
